var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5893 13.0893C15.2639 13.4147 14.7362 13.4147 14.4108 13.0893L10 8.67851L5.5893 13.0893C5.26386 13.4147 4.73622 13.4147 4.41078 13.0893C4.08535 12.7638 4.08535 12.2362 4.41078 11.9107L9.41078 6.91074C9.73622 6.5853 10.2639 6.5853 10.5893 6.91074L15.5893 11.9107C15.9147 12.2362 15.9147 12.7638 15.5893 13.0893Z",
    fill: "#DEE4EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.c4bd8ee6ce15c1752efdc291c2146caa.svg";
export { ForwardRef as ReactComponent };